import store from "../../store/store";
import * as TechnicianActions from "../../store/actions/schedulingportal/technicianAppointment";
import { max } from "lodash";

let materialLineIdData = 0;
let jobDurationData, serviceTotalFees, totalDuration, materialListData, serviceDetailsData, createJobResponse;

const resetData = () => {
  materialLineIdData = 0;
  jobDurationData = [];
  serviceTotalFees = 0;
  totalDuration = 0;
  store.dispatch(TechnicianActions.setServiceTotalFee(0));
  store.dispatch(TechnicianActions.setJobDurationDetails([]));
  store.dispatch(TechnicianActions.setEstAppointmentLength(0));
};

export const commercialAccountsJobDurationDetails = (serviceDetails, materialList, jobResponseData, vztSegment, brands) => {
  resetData();
  serviceDetailsData = [...serviceDetails];
  materialListData = materialList;
  createJobResponse = jobResponseData?.jobDurationDetails ?? [];
  let transferService = serviceDetailsData.length !== 0 && serviceDetailsData?.filter((item) => item.serviceType === "Transfer");

  function processAccessoryMaterial(accessory, cameraCount, serviceType, vztSegment, brands) {
    if (accessory === "No accessories connected") {
      return;
    }
    if (accessory === "Camera") {
      const quantityType = cameraCount === 1 ? "Single" : "Multiple";
      fetchMaterialData(accessory, serviceType, quantityType, vztSegment, brands);
    } else {
      fetchMaterialData(accessory, serviceType, "", vztSegment, brands);
    }
  };

  //Single Transfer service
  if (transferService.length === 1) {
    //Single main item
    fetchMaterialData("Main Item", "Transfer", "Single", vztSegment, brands);
    transferService[0]?.selectedCameraAndAccessories !== null &&
      transferService[0]?.selectedCameraAndAccessories.forEach((accessory) => {
        //Single camera or other accessories
        accessory !== "No accessories connected" && fetchMaterialData(accessory, "Transfer", "Single", vztSegment, brands);
      });
  } else {
    //count number of camera selected in Transfer service
    let cameraCount = transferService
      .filter((service) => service.selectedCameraAndAccessories !== null)
      ?.reduce((count, item) => {
        return count + item.selectedCameraAndAccessories.filter((accessory) => accessory === "Camera").length;
      }, 0);

    transferService &&
      transferService.length !== 0 &&
      transferService.forEach((serviceDetails) => {
        //Call main item for each service
        fetchMaterialData("Main Item", "Transfer", "Multiple", vztSegment, brands);
        serviceDetails?.selectedCameraAndAccessories?.forEach((accessory) => {
            //If only one camera is selected across multiple Service, single camera material id is added
            //If multiple cameras are selected across multiple service, multiple camera material id is added
            processAccessoryMaterial(accessory, cameraCount, "Transfer", vztSegment, brands);
        });
      });
  }

  let removalService = serviceDetailsData.length !== 0 && serviceDetailsData?.filter((item) => item.serviceType === "Removal");
  removalService &&
    removalService.length !== 0 &&
    removalService.forEach((serviceDetails) => {
      //Main item is added for removal service
      fetchMaterialData("Main Item", "Removal", "", vztSegment, brands);
      serviceDetails?.selectedCameraAndAccessories !== null &&
        serviceDetails?.selectedCameraAndAccessories.forEach((accessory) => {
          accessory !== "No accessories connected" && accessory === "Camera" && fetchMaterialData(accessory, "Removal", "", vztSegment, brands);
        });
    });

  //Update job API : if any accessories are deleted the isDelete is set to true
  if (createJobResponse && createJobResponse.length !== 0) {
    const ids = jobDurationData.map((obj) => obj["materialCode"]);
    const deletedData = createJobResponse.filter((item) => !ids.includes(item["materialId"]));
    deletedData.forEach((data) => {
      let item = data;
      item.isDeleted = true;
      item.quantity = 0;
      item.materialFunction = [{ fee: "0" }];
      item.duration = 0;
      mappingJobData(item, item?.processingCode, vztSegment, brands);
    });
  }
  
  // Remove fee properties from Redux store data (keep only for calculation)
  const cleanJobDurationData = jobDurationData.map(({ totalFee, customerServiceCharge, ...cleanData }) => cleanData);
  store.dispatch(TechnicianActions.setJobDurationDetails(cleanJobDurationData));

  //Calculate the total fees
  serviceTotalFees =
    jobDurationData?.length !== 0 &&
    jobDurationData.reduce((count, item) => {
      return count + item.totalFee;
    }, 0);
  store.dispatch(TechnicianActions.setServiceTotalFee(serviceTotalFees));

  //Calculate the total duration in minutes
  totalDuration =
    jobDurationData?.length !== 0 &&
    jobDurationData
      ?.filter((item) => item.processingCode === "ZSPO")
      ?.reduce((count, item) => {
        return count + item.quantity * item.itemDuration;
      }, 0);
  //If total duration is less than 1hr, round it off to 1 hr as minimum duration is 1 hr
  let roundOffTotalDuration = totalDuration < 60 ? 60 : totalDuration;
  store.dispatch(TechnicianActions.setEstAppointmentLength(roundOffTotalDuration));
  return roundOffTotalDuration;
};

const fetchMaterialData = (accessory, serviceType, quantity, vztSegment, brands) => {
  const processMaterialData = (materialId, processingCode1, processingCode2) => {
    let isUpdate = jobDurationData?.filter((item) => item.materialCode === materialId && item.processingCode === processingCode1).length !== 0;
    let data = materialListData?.data?.find((item) => item.materialId === materialId);
    if (!data) return; // Prevents crash if material not found
    if (isUpdate) {
      updateJobData(data, materialId, processingCode1, vztSegment, brands);
      if (processingCode2) updateJobData(data, materialId, processingCode2, vztSegment, brands);
    } else {
      mappingJobData(data, processingCode1, vztSegment, brands);
      if (processingCode2) mappingJobData(data, processingCode2, vztSegment, brands);
    }
  };

  switch (accessory) {
    case "Main Item":
      switch (serviceType) {
        case "Transfer":
          switch (quantity) {
            case "Single":
              processMaterialData("1300000017", "ZSPO", "ZBTP");
              break;
            case "Multiple":
              processMaterialData("1300000060", "ZSPO", "ZBTP");
              break;
          }
          break;
        case "Removal":
          processMaterialData("1300000016", "ZSPO", "ZBTP");
          break;
      }
      break;
    case "Camera":
      switch (serviceType) {
        case "Transfer":
          switch (quantity) {
            case "Single":
              processMaterialData("1300000118", "ZSPO", "ZBTP");
              break;
            case "Multiple":
              processMaterialData("1300000111", "ZSPO", "ZBTP");
              break;
          }
          break;
        case "Removal":
          processMaterialData("1300000110", "ZSPO", "ZBTP");
          break;
      }
      break;
    case "Driver ID":
      processMaterialData("1300000041", "ZSPO", null);
      break;
    case "Panic/privacy button":
      processMaterialData("1300000023", "ZSPO", null);
      break;
    case "Logbook":
      processMaterialData("1300000022", "ZSPO", null);
      break;
    case "Garmin":
      processMaterialData("1300000063", "ZSPO", null);
      break;
    case "Power Take Off (PTO)":
      processMaterialData("1300000021", "ZSPO", null);
      break;
  }
};

const getFee = (sourceData, sourceSegment, sourceBrand) => {
  const segmentStr = typeof sourceSegment === "string" ? sourceSegment.toLowerCase() : "";
  const brandStr = typeof sourceBrand === "string" ? sourceBrand.toLowerCase() : "";
  const isGovernmentSegment = segmentStr === "government";
  const hasSourcewellBrand = brandStr.includes("sourcewell");
  const fee = (isGovernmentSegment && hasSourcewellBrand)
    ? Number(sourceData?.sourceWellCustomerFee ?? 0)
    : Number(sourceData?.stdCustomerFee ?? 0);
  return fee;
};

const mappingJobData = (materialData, processCode, vztSegment, brands) => {
  if (!materialData) return;
  if (materialData) {
    let id = null;
    //Append the id if material id is already exisiting in create job response
    if (createJobResponse && createJobResponse.length !== 0) {
      id = createJobResponse?.find((item) => item?.materialId === materialData?.materialId && item?.processingCode === processCode)?.id;
    }
    let eachJobDurationData = {
      id: id ?? null,
      jobDurationId: null,
      orderType: null,
      techRefId: null,
      contractId: null,
      contractCode: null,
      contractName: null,
      customerPONumber: "",
      customerPONumberKut: null,
      materialLineId: 0,
      isDeleted: materialData?.isDeleted ?? false,
      reasonCode: null,
      adjustmentReasonCode: null, //  "adjustmentReasonCode":9 Manager Approval else null
      linkedMaterialLineId: null,
    };
    // Calculate fee using getFee function
    let cost = processCode === "ZBTP" ? getFee(materialData, vztSegment, brands) : 0;
    
    eachJobDurationData.quantity = processCode === "ZBTP" ? 0 : materialData?.quantity ?? 1;
    eachJobDurationData.unitMeasure = materialData.baseMeasurementUnit;
    eachJobDurationData.materialCode = materialData.materialId;
    eachJobDurationData.itemDescription = materialData.materialName;
    eachJobDurationData.wtMaterialId = materialData.wtMaterialId;
    //Item duration should be added only to ZSPO process code
    eachJobDurationData.itemDuration = processCode === "ZBTP" ? 0 : materialData.duration;
    eachJobDurationData.processingCode = processCode;
    // Set fee using calculated cost
    eachJobDurationData.customerServiceCharge = cost;
    eachJobDurationData.totalFee = cost;
    jobDurationData.push(eachJobDurationData);
  }
};

//update quantity and customerServiceCharge if material already exists
const updateJobData = (materialData, materialId, processCode, vztSegment, brands) => {
  if (!materialData) return;
  let materialDataIndex = jobDurationData?.findIndex((item) => item.materialCode === materialId && item.processingCode === processCode);
  if (materialDataIndex !== -1) {
    let quantity = jobDurationData[materialDataIndex].quantity;
    quantity++;
    jobDurationData[materialDataIndex].quantity = quantity;
    jobDurationData[materialDataIndex].itemDuration = processCode === "ZBTP" ? 0 : jobDurationData[materialDataIndex].itemDuration;
    if (processCode === "ZBTP") {
      let cost = jobDurationData[materialDataIndex].totalFee + getFee(materialData, vztSegment, brands);
      jobDurationData[materialDataIndex].totalFee = cost;
      jobDurationData[materialDataIndex].customerServiceCharge = getFee(materialData, vztSegment, brands);
      jobDurationData[materialDataIndex].quantity = 0;
    }
  }
};

//Add the materialLineId for each material
export const getLineIdForJobDurationDetails = (response, jobDuration, action) => {
  //If new materials are added to jobDurationDetails
  if (action === "add") {
    let materialLineId = 0;
    let jobDurationDetailsWithLineId = jobDuration.map((job) => {
      let materialUniqueId;
      //Increment the line item by 10 & lineItem id needs to be six digit
      materialLineId += 10;
      materialUniqueId = materialLineId.toString().padStart(6, "0");
      return {
        ...job,
        materialLineId: materialUniqueId,
      };
    });
    return getLinkedMaterailLineId(jobDurationDetailsWithLineId);
  } else {
    //Caluclate the maximum materialLineId exisiting
    let maxId = max(response.map((item) => (item.materialLineID ? Number(item.materialLineID) : 0)));
    let jobDurationDetailsWithLineId = jobDuration.map((job) => {
      let materialUniqueId;
      //Check if the materialId has id assigned, if not increment the value by 10
      if (!job?.id) {
        maxId += 10;
        materialUniqueId = maxId.toString().padStart(6, "0");
      } else {
        //Assign job's materialLineId
        let jobMaterialLineId = response?.find(
          (item) => item?.materialId === job?.materialCode && item?.processingCode === job?.processingCode
        )?.materialLineID;
        materialUniqueId = jobMaterialLineId;
      }
      return {
        ...job,
        materialLineId: materialUniqueId,
      };
    });
    return getLinkedMaterailLineId(jobDurationDetailsWithLineId);
  }
};

const getLinkedMaterailLineId = (jobDurationDetails) => {
  let jobDurationDetailsWithLinkedMaterailLineId = jobDurationDetails.map((data) => {
    if (data.processingCode === "ZSPO") {
      let matchingZBTP = jobDurationDetails.find((item) => item.materialCode === data.materialCode && item.processingCode === "ZBTP");
      if (matchingZBTP) data.linkedMaterialLineId = matchingZBTP.materialLineId;
    } else if (data.processingCode === "ZBTP") {
      let matchingZSPO = jobDurationDetails.find((item) => item.materialCode === data.materialCode && item.processingCode === "ZSPO");
      if (matchingZSPO) data.linkedMaterialLineId = matchingZSPO.materialLineId;
    }

    // Remove totalFee and customerServiceCharge properties from add/update job API payload
    const { totalFee, customerServiceCharge, ...materialLineData } = data;
    return materialLineData;
  });
  return jobDurationDetailsWithLinkedMaterailLineId;
};
